export default "__VITE_ASSET__nRuka8EI__"